module.exports = __webpack_public_path__ + "static/media/logo.f4a3dc20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.jpg
// module id = 161
// module chunks = 0